import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { TabsContent } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { Wallet, ExternalLink, ArrowRight } from 'lucide-react';

const Settlements = ({ dateRange }: { dateRange: { start_date: string; end_date: string } }) => {
  return (
    <TabsContent value='settlements' className='space-y-4'>
      <Card>
        <CardHeader className='px-3 pb-2 sm:px-6'>
          <div className='flex items-start gap-2 sm:gap-3'>
            <div className='flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg bg-brand-copper/10 sm:h-8 sm:w-8'>
              <Wallet className='h-3.5 w-3.5 text-brand-copper sm:h-4 sm:w-4' strokeWidth={2} />
            </div>
            <div>
              <CardTitle className='font-montserrat text-sm font-semibold text-slate-900 sm:text-base'>
                Settlements & Payouts
              </CardTitle>
              <p className='mt-0.5 text-xs text-slate-500 sm:text-sm'>
                Your payment settlements and payout history
              </p>
            </div>
          </div>
        </CardHeader>
        <CardContent className='px-3 pb-6 sm:px-6'>
          <div className='rounded-xl border border-blue-100 bg-gradient-to-br from-blue-50 to-indigo-50/40 p-6 text-center'>
            <div className='mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-white shadow-sm'>
              <Wallet className='h-7 w-7 text-brand-teal' strokeWidth={1.5} />
            </div>
            <h3 className='text-base font-semibold text-slate-900'>
              Settlements are managed via Stripe
            </h3>
            <p className='mx-auto mt-2 max-w-sm text-sm text-slate-600'>
              Your payouts and settlement history are available directly in your Stripe Connect
              dashboard with real-time data and detailed breakdowns.
            </p>
            <div className='mt-5 flex flex-col items-center gap-3 sm:flex-row sm:justify-center'>
              <Button
                size='sm'
                className='h-9 gap-2 bg-brand-teal hover:bg-brand-teal/90'
                onClick={() => window.open('https://dashboard.stripe.com/payouts', '_blank')}
              >
                View Payouts in Stripe
                <ExternalLink className='h-3.5 w-3.5' />
              </Button>
              <Button
                size='sm'
                variant='outline'
                className='h-9 gap-2'
                onClick={() =>
                  window.open('https://dashboard.stripe.com/balance/overview', '_blank')
                }
              >
                Balance Overview
                <ArrowRight className='h-3.5 w-3.5' />
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </TabsContent>
  );
};

export default Settlements;
